import { useEffect, useState } from 'react';
import type { TopBarLinksType } from '../constants';
import { topNavFallbackData } from '../constants';
import { getServerUrl } from '../utils/getServerUrl';
import { isEmptyObject } from '../utils/isEmptyObject';

export const useTopNav = (zapidentity: string | number) => {
  const [isLoading, setIsLoading] = useState(true);
  const [topNav, setTopNav] = useState<TopBarLinksType>(topNavFallbackData);

  useEffect(() => {
    let apiSubscribed = true;

    async function getTopnavData() {
      const serverUrl = getServerUrl();
      const topnavUrl = `${serverUrl}/navigation-data/topbar`;
      const fetchData = {
        headers: { 'x-zapidentity-id': zapidentity.toString() },
      };

      try {
        setIsLoading(true);
        const response = await fetch(topnavUrl, fetchData);
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          if (!isEmptyObject(data)) setTopNav(data);
        }
      } catch (error) {
        setTopNav(topNavFallbackData);
      } finally {
        setIsLoading(false);
      }
    }

    getTopnavData();

    return () => {
      apiSubscribed = false;
    };
  }, [zapidentity]);

  return { isLoading, topNav };
};
